import React, { useEffect } from "react";
import { HumanizerInput, TransparentText, CheckedByLogos } from "@components";
import styles from "./style.module.scss";
import { ReactComponent as ShadowChatIcon } from "./assets/img/ShadowChat.svg";

import background from "./assets/img/1st_screen.webp";
import sparkle from "./assets/img/sparkle.svg";
import { useNavigate } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import i18next from "i18next";
import { ReactComponent as Stars5Icon } from "../../../assets/trustpilot/stars-5-1.svg";
import { ReactComponent as TrustpilotIconSvg } from "../../../assets/trustpilot/trustpilot-1.svg";

declare global {
	interface Window {
		Trustpilot: any;
	}
}

export const Humanizer: React.FC = () => {
	const navigate = useNavigate();

	const { t } = useTranslation();

	return (
		<div className={styles.Humanizer}>
			<div className={styles.Humanizer__content}>
				<div className={styles.Humanizer__backgroundNoise} />
				<div className={`app-container ${styles.Humanizer__positionWrapper}`}>
					<div className={styles.Humanizer__textContainer}>
						<h1 className={styles.Humanizer__title}>
							<Trans
								i18nKey="humanizer.title"
								components={{
									transparent: <TransparentText />,
								}}
							/>
						</h1>
						<p className={styles.Humanizer__description}>
							<Trans i18nKey="humanizer.description" />
						</p>
					</div>
					<HumanizerInput className={styles.Humanizer__input} />
					<div className={styles.Humanizer__bottomContainer}>
						<div className={styles.Humanizer__trustpilotWrapper}>
							<strong>Excellent</strong>
							<Stars5Icon />
							<TrustpilotIconSvg />
							<span className={styles.Humanizer__trustpilotText}>
								by 25000+ students and educators
							</span>
						</div>
						<CheckedByLogos />
					</div>
				</div>
			</div>
		</div>
	);
};
